import { Component, EventEmitter, OnInit, Output, inject } from "@angular/core";
import { AbstractControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FlexDirective, LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { ForgeButtonModule } from "@tylertech/forge-angular";
import { LgdFormControlFactory, LgdTextComponent } from "@tylertech/lgd-reactive-forms";
import { SecurityService, ToastService, UserService } from "../../../services";
import { SecurityScreenType } from "../securityScreenType";

@Component({
    selector: "forgot-password-form",
    templateUrl: "./forgotPasswordForm.tmpl.html",
    styleUrls: [
        "./forgotPasswordForm.component.scss"
    ],
    imports: [
        FlexDirective,
        LayoutAlignDirective,
        LayoutDirective,
        ForgeButtonModule,
        LgdTextComponent,
        ReactiveFormsModule
    ]
})
export class ForgotPasswordFormComponent implements OnInit
{
    private readonly $securityService = inject(SecurityService);
    private readonly $userService = inject(UserService);
    private readonly $toastService = inject(ToastService);


    @Output() protected readonly goto = new EventEmitter<SecurityScreenType>();

    readonly mainForm: FormGroup;

    sent: boolean;
    busy: boolean;

    constructor()
    {
        this.mainForm = new FormGroup({
            username: LgdFormControlFactory.text(undefined, true, {}),
        });
    }

    protected get usernameControl(): AbstractControl<string>
    {
        return this.mainForm.get("username");
    }

    ngOnInit(): void
    {
        // TODO - why do we ever have quotes in the username value?
        const username = this.$securityService.Username?.replace(/"/g, "");
        this.usernameControl.setValue(username);
    }

    onCancel(): void
    {
        this.goto.emit(SecurityScreenType.Login);
    }

    onSubmit(): Promise<void>
    {
        if (!this.usernameControl.value)
        {
            return Promise.reject();
        }

        const self = this;

        this.busy = true;
        return this.$userService.EmailPasswordResetLink(this.usernameControl.value)
            .then(() =>
            {
                self.$toastService.showToast("Submission Complete", 2000);
            })
            .finally(() =>
            {
                self.sent = true;
                self.busy = false;
            });
    }
}
